import React, { useEffect, useContext } from "react";
import { PricingDisplayMethodContext } from "/src/helpers/contexts/agentContext.jsx";
import formatMoney from "/src/helpers/formatMoney";
const DEFAULT_OPTIONS = {
    allowShortForm: false,
    removeCurrencySymbol: false,
    forceTotal: false,
    removePostfix: false,
    round: true,
    useAbsolute: false,
    showPrefix: true,
    valueModifier: (x) => x,
};
export function useMoneyFormatter() {
    const [pricingDisplayMethod, setPricingDisplayMethod] = useContext(PricingDisplayMethodContext);
    const isPerPerson = pricingDisplayMethod == "pp";

    const format = (obj, opts) => {
        if (!obj) {
            return "";
        }

        const options = { ...DEFAULT_OPTIONS, ...opts };

        const showAsPP = isPerPerson && !options.forceTotal;

        if (options.useAbsolute) {
            if (obj.type == "relative") {
                obj = obj.preRelativised;
            }
        }
        let priceNumbers;
        if (showAsPP) {
            priceNumbers = obj.pricePP;
        } else {
            priceNumbers = obj.price;
        }
        priceNumbers = options.valueModifier(priceNumbers);

        if (options.round) {
            priceNumbers = Math.round(priceNumbers);
        }

        let text = "";
        if (options.showPrefix) {
            if (obj.type == "relative") {
                if (priceNumbers < 0) {
                    text = "-";
                    priceNumbers = Math.abs(priceNumbers);
                } else {
                    text = "+";
                }
            }
        }

        if (!options.removeCurrencySymbol) {
            text = text + "£";
        }
        text = text + formatMoney(priceNumbers, options.allowShortForm || options.round);

        if (showAsPP && !options.removePostfix) {
            text = text + "pp";
        }

        return text;
    };

    return [format, isPerPerson, setPricingDisplayMethod];
}
